// store/index.ts
// store/index.ts
import { configureStore } from "@reduxjs/toolkit";
import subnetReducer from "./subnetSlice";

export const store = configureStore({
  reducer: {
    subnet: subnetReducer,
  },
});

// 🔑 类型定义
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
